// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/accelerated-secondary-stalls.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/accelerated-secondary-stalls/accelerated-secondary-stalls.js';

mount([g0]);
